module.exports = __webpack_public_path__ + "img/detail4.3c1a46c6.png";